import BatteryProperty from './batteryProperty';

export default BatteryProperty;
